export default __webpack_public_path__ + "44b9997f9e2a55015a0e1670d8553bdc.png";